/**
 * Back to top button.
 *
 * Shows after scrolling 400px, smooth scrolls to top on click.
 */

(function () {
  var btn = document.querySelector('.back-to-top');
  if (!btn) return;

  var threshold = 400;

  window.addEventListener(
    'scroll',
    function () {
      if (window.scrollY > threshold) {
        btn.classList.add('is-visible');
      } else {
        btn.classList.remove('is-visible');
      }
    },
    { passive: true },
  );

  btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();
